import styled from 'styled-components';
import {baseStyle} from '../styles';

export const Padding = styled.div`
  ${baseStyle}
`;
